'use strict';

var $ = require('jquery');
import { has, bind } from 'lodash';

var ComponentUtils = require('./ComponentUtils');
var DomElementUtils = require('../utils/DomElementUtils');

/** @module DropIndicator
 * @requires jquery
 * @requires lodash
 * @requires ComponentUtils
 * @requires DomElementUtils
 */
function DropIndicator() {
	var _indicator = $("<div>").prop({ id: "drop-indicator" });

	this._isComponentDrag = function (ev) {
		var data = JSON.parse(ev.dataTransfer.getData('text'));
		return has( data, 'componentId') || ( has( data, name) && has( data, 'version') );
	};

	this.showHighlight = function(ev) {
		if (!this._isComponentDrag(ev)) return;

		var component = ComponentUtils.GetComponentElement(ev.target);
		if (component) this.render(component, ev);

		ev.preventDefault();
		return false;
	};

	this.setup = function(element) {
		var $el = $(element);
		$el.append(_indicator);
		// Append an empty div: sections are styled as nth-child(odd), so we need to
		// make sure that stays the same in the editor / published site.
		$el.append('<div>');
		$el.on("dragover", bind(this.showHighlight, this));

		this.destroy();
		this.observer = new MutationObserver(bind(_indicator.hide, _indicator));
		this.observer.observe(element, { childList: true });
	};

	this.destroy = function() {
		if(!this.observer) return;

		this.observer.disconnect();
		this.observer = null;
	};

	this.render = function(component, ev) {
		var indent = 2,
			height = 50,
			size = DomElementUtils.GetElementRect(component);

		var heightOffset = DomElementUtils.IsCoordinatesInBottom(
			ev.originalEvent.pageX,
			ev.originalEvent.pageY,
			component)
			? size.height : 0;

		_indicator
			.css({
				width: size.width - indent * 2,
				height: height,
				left: size.left + indent,
				top: (size.top + heightOffset) - height / 2
			})
			.show();
	};
}

module.exports = DropIndicator;
